export const DISPATCH_OPEN_GAMEIFRAME_EVENT = 'openGameIFrame';
